const routes = [
  {
    path: '',
    name: 'CourseListTasks',
    component: () => import('./pages/CourseList.vue'),
    meta: {
      title: 'Мои курсы',
      authorize: [],
    },
  },
  {
    name: 'TaskPass',
    path: '/task-pass/:id',
    component: () => import('./pages/TaskPass.vue'),
    meta: {
      title: 'Прохождение задания',
      authorize: [],
    },
  },
  {
    name: 'TaskListForPass',
    path: '/:courseId/:groupId',
    component: () => import('./pages/TaskList.vue'),
    meta: {
      title: 'Список заданий для прохождения',
      authorize: [],
    },
  },
];

export default routes;
